import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  nextField: {
    backgroundColor: theme.palette.secondary.light,
    width: "160px",
    borderRadius: "10px",
  },
}));
